<div class="cylinder">
  <div class="reflect"></div>
  <ng-container *ngFor="let item of list">
  	<div class="water" [ngStyle]="item.css" *ngIf="item.display" >
      <label class="form-label" *ngIf="item.libelle">{{item.libelle}}</label>
    </div>
  </ng-container>
</div>

